module.exports = __webpack_public_path__ + "static/media/Hong Kong.c060daac.jpg";